import { render, staticRenderFns } from "./FieldRejectionFeedback.vue?vue&type=template&id=2050b40e&scoped=true&"
import script from "./FieldRejectionFeedback.vue?vue&type=script&lang=js&"
export * from "./FieldRejectionFeedback.vue?vue&type=script&lang=js&"
import style0 from "./FieldRejectionFeedback.vue?vue&type=style&index=0&id=2050b40e&prod&scoped=true&lang=scss&"
import style1 from "./FieldRejectionFeedback.vue?vue&type=style&index=1&id=2050b40e&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2050b40e",
  null
  
)

export default component.exports